<template>
<div class="form__item">
    <label :for="id" class="input__label">
        <slot name="label"></slot>
        <span v-if="required == true" style="color: red;">*</span>
    </label>
    
    <div v-if="image == true">
        <label class="input__file--container">
            <input v-on:change="onchange(id)" :id="id" class="input__file js-input__file" type="file" accept="image/*" aria-label="file" :disabled="disabled" :required="required" ref='input'>
            <span :class="[ classes ]" class="input__file--button-img button--blue">Choose File</span>
            <span class="input__file--text" :data-input="id">No file chosen</span>
        </label>
    </div>
    <div v-else>
        <label class="input__file--container">
            <input v-on:change="onchange(id)" :id="id" class="input__file js-input__file" type="file" aria-label="file" :disabled="disabled" :required="required" ref='input'>
            <span :class="[ classes ]" class="input__file--button button--blue">Choose File</span>
            <span class="input__file--text" :data-input="id">No file chosen</span>
        </label>
    </div>
</div>
</template>

<script>
export default {
    props: {
        id: { type: String, default: null },
        required: { type: Boolean, default: false },
        autofocus: { type: Boolean, default: false },
        disabled: {type: Boolean, default: false},
        image: {type: Boolean, default: false},
        value: {
            validator: prop => ['string', 'number'].includes(typeof prop) || prop === null,
            default: null
        }
    },
    computed: {
        inputValue: {
            get () {
                return this.value
            },
            set (value) {
                this.emitValue(value)
            }
        },
        classes () {
            const { disabled } = this
            
            return [
                ...(disabled ? [`disabled`] : [null]),
            ]
        },
    },
    methods: {
        emitValue (value) {
            this.$emit('input', value)
        }, 
        onchange(el) {
            this.inputValue = document.getElementById(el).value
            const id = el;
            const file = this.getAllElementsWithAttribute('data-input', id);

            file[0].classList.add('active');
            file[0].textContent = document.getElementById(el).value
        },

        getAllElementsWithAttribute(attribute, value) {
            const matchingElements = [];
            const allElements = document.getElementsByTagName('*');
            for (let i = 0, n = allElements.length; i < n; i++) {
                if (allElements[i].getAttribute(attribute) == value) {
                    matchingElements.push(allElements[i]);
                }
            }
            return matchingElements;
        }
    },
    mounted() {
        this.autofocus ? this.$refs.input.focus() : ''
    }
}

</script>